<div id="show-quiz" role="main">
    <div class="card">
        <h6 class="card-header text-center" *ngIf="subTopic.server_subtopic_id!=0"> 
        {{subTopic.name}}
        </h6>
        <div *ngFor="let conceptItem of conceptList;">
            <h5>{{conceptItem.title}</h5>
            <div>{{conceptItem.description}}</div>
        </div>
        <div class="alert alert-info text-center" *ngIf="conceptList.length==0">
            No Concepts Found. We are working on it ..
        </div>
</div>
</div>